import { FunctionComponent } from 'react';
import { DraftConfiguration } from '@/types';
import { t } from '@/utils/i18n';
import { getPrintAreaLabel } from '@/model/printArea/getPrintAreaLabel';
import { PrintAreaSelector } from '@/components/common/PrintAreaSelector';
import { SubPanel } from '@/components/common/panel/panel';

interface Props {
  active: boolean;
  configuration: DraftConfiguration;
  onClose: () => void;
}

export const PrintAreaPanel: FunctionComponent<Props> = ({ active, configuration, onClose }) => (
  <SubPanel
    active={active}
    headline={t(getPrintAreaLabel())}
    parent={t('designSettings.label')}
    onBack={onClose}
  >
    <PrintAreaSelector configuration={configuration} onClose={onClose} />
  </SubPanel>
);
